import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { firebaseLogEvent } from 'utils/firebase';

import { ProfileMenuButtonImage } from './ProfileMenuButtonImage';

const ProfileContents = dynamic(() => import('./ProfileContents').then(mod => mod.ProfileContents));

interface Props {
  avatarUrl?: string;
  name?: string;
}

export const Profile = ({ avatarUrl, name }: Props) => {
  const { t } = useTranslation('common');

  return (
    <Popover>
      {({ open }) => (
        <>
          <PopoverButton
            aria-label={t('giving.labels.profile_menu')}
            className='flex items-center justify-center bg-transparent rounded-full size-auto !p-0'
            onClick={() => firebaseLogEvent('GivingButtonTap', { label: 'Giving Menu', screen: 'giving_form' })}
          >
            <ProfileMenuButtonImage avatarUrl={avatarUrl} name={name} />
          </PopoverButton>

          {/** We need to recreate a fdocus lock. */}
          <PopoverPanel
            anchor={{ gap: 8, to: 'bottom end' }}
            className='pbe-3 pbs-2 pli-2 bg-canvas-light dark:bg-canvas-secondary-dark rounded-1 shadow-light-2  w-[300px] z-1'
          >
            {open ? <ProfileContents /> : null}
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
};
